import { IconButton, Snackbar } from '@mui/material';
import Alert, { AlertColor } from '@mui/material/Alert';
import Grow, { GrowProps } from '@mui/material/Grow';
import { useRef, useState, useEffect } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';

export default function Notification({
  close,
  message,
  severity,
}: {
  close: () => void;
  message: string;
  severity: AlertColor;
}) {
  const masterMessageRef = useRef<HTMLDivElement | null>(null);
  // FIXME ez szerintem nem kell
  const [masterWidth, setMasterWidth] = useState<number | null>(null);

  useEffect(() => {
    if (masterMessageRef.current) {
      setMasterWidth(masterMessageRef.current.offsetWidth);
    }
  }, [message]);

  function GrowTransition(props: GrowProps) {
    return <Grow {...props} />;
  }

  function getMessage(message: string) {
    const lines = message.split('\n');
    if (lines.length == 1) {
      return message;
    }
    return (
      <>
        <div
          ref={masterMessageRef}
          style={{
            fontWeight: 'bold',
            display: 'inline-block',
          }}
        >
          {lines[0]}
        </div>

        {lines.slice(1).map((line, index) => (
          <div
            key={index}
            style={{
              fontWeight: 'normal',
              fontSize: '0.7rem',
              wordWrap: 'break-word',
              maxWidth: masterWidth ? `${masterWidth}px` : '100%',
            }}
          >
            {line}
          </div>
        ))}
      </>
    );
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={true}
      slots={{
        transition: GrowTransition,
      }}
    >
      <Alert
        onClose={close}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          userSelect: 'none',
          msUserSelect: 'none',
          WebkitUserSelect: 'none',
          '& .MuiAlert-message': { whiteSpace: 'pre-line' },
        }}
        action={
          <IconButton aria-label="close" onClick={close} data-qa-element-id="close-notification" size="small">
            <CloseIcon fontSize="small" sx={{ color: 'white' }} />
          </IconButton>
        }
      >
        {getMessage(message)}
      </Alert>
    </Snackbar>
  );
}
